var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var controllers;
    (function (controllers) {
        var ViewSecurityMatrixModalController = /** @class */ (function (_super) {
            __extends(ViewSecurityMatrixModalController, _super);
            function ViewSecurityMatrixModalController($scope, securityMatrixService, securityMatrixId, close) {
                var _this = _super.call(this, $scope, close) || this;
                _this.$scope = $scope;
                _this.securityMatrixService = securityMatrixService;
                _this.scope = $scope;
                _this.scope.securityMatrixId = securityMatrixId;
                _this.scope.flatRowsToUse = function () { return _this.flatRowsToUse(); };
                _this.scope.filterRows = function () { return _this.filterRows(); };
                _this.initialize();
                return _this;
            }
            ViewSecurityMatrixModalController.prototype.initialize = function () {
                var _this = this;
                this.$scope.criteria = {
                    statusFilterText: '',
                    authorityFilter: 'NONE',
                    combineLikeRoles: true
                };
                this.securityMatrixService.getSecurityMatrixView(this.$scope.securityMatrixId)
                    .then(function (dto) {
                    _this.$scope.securityMatrixViewDto = dto;
                    _this.$scope.filterRows();
                });
            };
            ViewSecurityMatrixModalController.prototype.flatRowsToUse = function () {
                return this.$scope.criteria.combineLikeRoles ? this.$scope.mergedRows : this.$scope.flatRows;
            };
            ViewSecurityMatrixModalController.prototype.filterRows = function () {
                var _this = this;
                if (this.$scope.criteria.authorityFilter === undefined || this.$scope.criteria.authorityFilter === 'NONE') {
                    this.$scope.flatRows = Enumerable.from(this.$scope.securityMatrixViewDto.flatRows)
                        .where(function (i) { return i.statusOrState.toLowerCase().indexOf(_this.scope.criteria.statusFilterText.toLowerCase()) !== -1; })
                        .toArray();
                    this.$scope.mergedRows = Enumerable.from(this.$scope.securityMatrixViewDto.flatMergedRows)
                        .where(function (i) { return i.statusOrState.toLowerCase().indexOf(_this.scope.criteria.statusFilterText.toLowerCase()) !== -1; })
                        .toArray();
                }
                else {
                    this.$scope.flatRows = Enumerable.from(this.$scope.securityMatrixViewDto.flatRows)
                        .where(function (i) { return i.statusOrState.toLowerCase().indexOf(_this.scope.criteria.statusFilterText.toLowerCase()) !== -1; })
                        .where(function (i) { return i.authority === _this.$scope.criteria.authorityFilter; })
                        .toArray();
                    this.$scope.mergedRows = Enumerable.from(this.$scope.securityMatrixViewDto.flatMergedRows)
                        .where(function (i) { return i.statusOrState.toLowerCase().indexOf(_this.scope.criteria.statusFilterText.toLowerCase()) !== -1; })
                        .where(function (i) { return i.authority === _this.$scope.criteria.authorityFilter; })
                        .toArray();
                }
            };
            return ViewSecurityMatrixModalController;
        }(controllers.BaseModalController));
        controllers.ViewSecurityMatrixModalController = ViewSecurityMatrixModalController;
    })(controllers = warsApp.controllers || (warsApp.controllers = {}));
})(warsApp || (warsApp = {}));
warsApp.registerController('ViewSecurityMatrixModalController', ['$scope', 'securityMatrixService', 'securityMatrixId', 'close']);
